import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AIModelManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        AI Model Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>AI model yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default AIModelManagement;
